<template>
  <section id="how-it-works" class="how-section home-section">
    <img
      class="how-background"
      src="@/assets/images/nursing-how-it-works-generated.jpg"
      alt=""
      width="1774"
      height="887"
      loading="lazy"
      decoding="async"
    >
    <div class="container">
      <div class="section-heading">
        <p class="eyebrow">02 / {{ $t("experience.howLabel") }}</p>
        <h2>{{ $t("experience.howTitle") }}</h2>
      </div>
      <ol class="care-steps">
        <li v-for="step in 3" :key="step">
          <span class="step-number" aria-hidden="true">0{{ step }}</span>
          <h3>{{ $t(`experience.step${step}Title`) }}</h3>
          <p>{{ $t(`experience.step${step}Text`) }}</p>
        </li>
      </ol>
      <div class="care-support">
        <div>
          <h3>{{ $t("experience.supportTitle") }}</h3>
          <p>{{ $t("experience.supportText") }}</p>
        </div>
        <a class="btn btn-primary" href="tel:+35794099400"><i class="fa fa-phone" aria-hidden="true"></i> +357 94 099400</a>
      </div>
    </div>
  </section>
</template>
<script>
export default { name: "HowItWorks" }
</script>

<style scoped lang="scss">
.how-section {
  position: relative;
  isolation: isolate;
  background: #063f51;
  color: #fff;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    background: linear-gradient(105deg, rgba(3, 42, 55, .91), rgba(3, 42, 55, .76));
    pointer-events: none;
  }

  .section-heading h2,
  .eyebrow,
  .step-number,
  .care-steps h3,
  .care-steps p,
  .care-support h3,
  .care-support p {
    color: #fff;
  }

  .care-steps li { border-top-color: rgba(255, 255, 255, .45); }

  .care-support {
    background: rgba(3, 42, 55, .65);
    border: 1px solid rgba(255, 255, 255, .3);
  }
}
.how-background {
  position: absolute;
  inset: 0;
  z-index: -2;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}
@media (max-width: 700px) {
  .how-background { object-position: 72% center; }
}
</style>
